import styled from "styled-components"

/** ID displays a system identifier in a consistent manner.
 * For an ID that links somewhere, see IDLink. */
const ID = styled.span`
  font-family: "Courier New", fixed;
  color: ${(props) => props.theme.colours.identifier};
`

export default ID
